export const escapeStructKey = (str: string): string =>
  /^[a-zA-Z_0-9]+$/.test(str) ? str : stringLit(str);

export const escapeString = (str: string): string =>
  str
    .replaceAll('\\', '\\\\')
    .replaceAll('\n', '\\n')
    .replaceAll('\r', '\\r')
    .replaceAll('\t', '\\t')
    .replaceAll('`', '\\`')
    .replaceAll(`'`, `\\'`);

export const stringLit = (str: string) => `'${escapeString(str)}'`;
